import { BaseRouteService } from 'core/services';

class DiagnosisCodeRouteService extends BaseRouteService {
    constructor() {
        super('diagnosis-codes');
    }

    find(filter) {
        return super.find(this.base + '/{?itemCategoryId,isBillable,searchQuery,page,rpp,sort,embed,fields}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }
    
    getExisting(abrv) {
        return super.find(this.base + '/existing/{?abrv}', {abrv:abrv});
    }
}

export default DiagnosisCodeRouteService;